<form [formGroup]="formGroup">
  <div class="delivery-promise-restriction-wrapper" [formGroupName]="'deliveryPromiseRestriction'">
    <pdq-checkbox formControlName="enabled" label="Don’t show delivery promise if..." labelSize="small"></pdq-checkbox>

    @if (formGroup.get('deliveryPromiseRestriction.enabled')?.value && optionsInitialized) {
      <pdq-rules-dynamic-form
        [formGroup]="formGroup.get('deliveryPromiseRestriction') | asFormGroup"
        formArrayFieldName="rules"
        [rules]="deliveryPromiseRestrictionRules"
        [entities]="deliveryPromiseRestrictionEntities"
        logicalOperator="Or"
        (onRemove)="onRuleRemove($event)"></pdq-rules-dynamic-form>

      <pdq-input
        label="Fallback text"
        invalidMsg="Fallback text is required"
        formControlName="fallbackText"
        placeholder="Enter fallback text"
        [tooltip]="'This fallback text will appear once all your rules wont match.'"></pdq-input>
    }
  </div>
</form>
